<template>
    <header>
        <div id="mypage-sidemenu-nav-drawer">
            <input id="mypage-sidemenu-nav-input" v-model="side_open" type="checkbox" class="mypage-sidemenu-nav-unshown">
            <label id="mypage-sidemenu-nav-open" for="mypage-sidemenu-nav-input">
                <span class="hunberger-icon"></span>
                <div class="content">MENU</div>
            </label>
            <label class="mypage-sidemenu-nav-unshown" id="mypage-sidemenu-nav-close" for="mypage-sidemenu-nav-input"></label>
            <div id="mypage-sidemenu-nav-content">
                <nav>
                    <div class="mypage-sidemenu-close-container">
                        <label class="mypage-sidemenu-nav" for="mypage-sidemenu-nav-input">
                            <label id="button" for="mypage-sidemenu-nav-input"><span></span></label>
                            <div class="content">CLOSE</div>
                        </label>
                    </div>
                    <template v-for="link in links">
                        <!-- 内部リンク -->
                        <router-link
                            v-if="link.to === '/golf-course-list'"
                            class="nav-link inner-item"
                            :to="{name: 'GolfCourseLisst', params: {show: true}}"
                            :name="link.name"
                            :key="link.name"
                            active-class="nav-link select-items"
                        >
                            <div class="mypage-sidemenu-icon" :class="link.iconclass"></div>
                            <div class="content">{{ link.title }}</div>
                        </router-link>
                        <router-link
                            v-else-if="link.to !== null && link.childhas === false && link.external_link === 0"
                            class="nav-link inner-item"
                            :to="link.to"
                            :name="link.name"
                            :key="link.name"
                            active-class="nav-link select-items"
                        >
                            <div class="mypage-sidemenu-icon" :class="link.iconclass"></div>
                            <div class="content">{{ link.title }}</div>
                        </router-link>

                        <!-- 外部リンク -->
                        <a v-else-if="link.to !== null && link.childhas === false && link.external_link !== 0"
                            :href="link.to"
                            :key="link.name"
                            class="nav-link inner-item"
                            active-class="nav-link select-items"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div class="mypage-sidemenu-icon" :class="link.iconclass"></div>
                            <div class="content">{{ link.title }}</div>
                        </a>

                        <!-- サブメニューがある場合 -->
                        <template v-else-if="link.childhas === true" >
                            <div class="nav-link inner-item"
                                :key="link.name"
                                :data-id="link.id"
                                v-on:click="displayChildToggle"
                            >
                                <div class="mypage-sidemenu-icon" :class="link.iconclass"></div>
                                <div class="toggle-row-line content">{{ link.title }}
                                    <div class="arrow-icon" :class="{ 'arrow-anime': link.arrow_anime }">&or;</div>
                                </div>
                            </div>

                            <div
                                :key="link.name"
                                class="childDiv"
                                :data-parent-id="link.id"
                                :class="link.childObj"
                            >
                                <template v-for="child in link.children">
                                    <!-- 内部リンク -->
                                    <router-link
                                        v-if="child.to !== null && child.external_link === 0"
                                        :key="child.id"
                                        :to="child.to"
                                        :name="child.name"
                                        class="child-item"
                                        active-class="nav-link select-items"
                                    >
                                        <div style="text-align: left; padding: 10px 0 10px 40px;">{{ child.title }}</div>
                                    </router-link>

                                    <!-- 外部リンク -->
                                    <a v-else-if="child.to !== null && child.external_link !== 0"
                                        :href="child.to"
                                        :key="child.id"
                                        class="child-item"
                                        active-class="nav-link select-items"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <div style="text-align: left; padding: 10px 0 10px 40px;">{{ child.title }}</div>
                                    </a>
                                </template>
                            </div>
                        </template>
                    </template>
                    <div
                         v-if="helpShow"
                        class="nav-link logout"
                        @click="logOutBtn">
                        <div class="mypage-sidemenu-icon sideiconlogout"></div>
                        <div class="logout-content">ログアウト</div>
                    </div>
                </nav>
            </div>
        </div>
    </header>
</template>

<script>
import { MEMBER_LOG_OUT } from "../../constants/signout";
import { mapGetters } from "vuex";
import { GET_MEMBER_RANK , GET_MENU} from '../../constants/mypage_side_menu';
import axios from 'axios';

export default {
    props: ['memberDropClose'],
    data() {
        return {
            // メニュー情報
            links:[],
            // メニューの表示非表示
            side_open: false,
            // 会員種別
            member_no: '',
            line_menu_no: '',
            lineSetting: 0,
            // ヘルプ表示
            helpShow: process.env.MIX_STYLE_NAME == 'hcgc' ? false: true,
        };
    },
    computed: {
        ...mapGetters('auth', [
            "loginMemberLineFlag"
        ])
    },
    created() {
        this.initialize();
    },
    watch: {
        // サイドメニューを開いてるときは背景のスクロールを禁止にする処理
        // bodyタグにクラスをトグルして制御
        side_open (val) {
            if (val) {
                this.bodyClassToggle(true);
            } else {
                this.bodyClassToggle(false);
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
            // LINE機能の利用有無を取得する
            this.lineSetting = this.$store.state.auth.settingValueLine;
            // メニュー取得
            this.GetMenuList();
            // // 初期表示はfalseにする。
            this.side_open = false;
            // // 初期表示はfalseにする
            this.bodyClassToggle(false);
        },
        /** ----------------------------------------------
         * メニューを取得
         * ---------------------------------------------- */
        GetMenuList: async function () {
            this.member_no = this.$store.state.auth.loginMember.member_no;

            // メニューの情報を取得
            this.links = await this.getData(this.member_no);
            // LINEの番号設定
            this.line_menu_no = '11';

            // LINEのメニュー切り替え
            this.sideMenuLinkSelect();
        },
        /** ----------------------------------------------
         * メニュー情報取得
         * ---------------------------------------------- */
        async getData(memberNo){
            let res = await this.$apollo.query({
                query: GET_MENU,
                variables: {
                    memberNo: memberNo
                }
            });

            var getMenu = res.data.GetMenu;
            if(getMenu != undefined){
                var menu_list = [];
                for (let i = 0; i < getMenu.length; i++){
                    var ele = getMenu[i];

                    // サブメニューが必要のものは取得
                    if(ele['childhas'] != false){
                        // サブメニューに現在表示している画面のものがあった場合はサブメニュー開いた状態で表示
                        // ルートと一致する行番号を取得
                        const toMap = ele['children'].map((obj) => { return obj.to; });
                        let getLine = toMap.indexOf(this.$route.path);
                        var dNone = true;
                        if(getLine > -1){
                            // サブメニュー表示
                            dNone = this.memberDropClose;
                        }
                        // サブメニューの表示非表示 設定
                        ele['childObj'] = {'d-none': dNone};
                        ele['arrow_anime'] = !dNone;
                    }
                    menu_list.push(ele);
                };
            }

            return menu_list;
        },
        /** ----------------------------------------------
         * メニューの表示内容を変更
         * ---------------------------------------------- */
        sideMenuLinkSelect: function () {
            // LINE機能を利用しない場合はリストから消去する
            if (this.lineSetting==1 && process.env.MIX_STYLE_NAME != 'hcgc') {

                // 一致する行番号を取得
                const idMap = this.links.map((obj) => { return obj.id; });
                let getLine = idMap.indexOf(this.line_menu_no);

                // 行が存在する場合のみ変更
                if(getLine > -1){
                    // // Line連携状態確認
                    if (this.loginMemberLineFlag) {
                        this.links[getLine].title = "LINEアカウント連携解除";
                        this.links[getLine].to = "/mypage-line-setting-quit";
                        this.links[getLine].name = "mypage-line-setting-quit";
                    } else {
                        this.links[getLine].title = "LINEアカウント連携";
                        this.links[getLine].to = "/mypage-line-setting";
                        this.links[getLine].name = "mypage-line-setting";
                    }
                }
            } else if (this.lineSetting != 1 && process.env.MIX_STYLE_NAME != 'hcgc') {
                this.links.splice(this.line_menu_no, 1);
            }
        },
        /** ----------------------------------------------
         * ログアウト処理
         * ---------------------------------------------- */
        logOutBtn: function () {
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$router.push('/');
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        /** ----------------------------------------------
         * サイドメニューを開いてるときは背景のスクロールを禁止にする処理
         * trueで禁止,falseで解除
         * ---------------------------------------------- */
        bodyClassToggle (flag) {
            if (flag) {
                document.body.classList.add('fix-body');
            } else {
                document.body.classList.remove('fix-body');
            }
        }
        /** ----------------------------------------------
         * 子メニューの表示、非表示処理
         * ---------------------------------------------- */
        , displayChildToggle: function (event) {
            // クリックしたID取得
            var ele   = event.target,
                dataId = ele.parentNode.getAttribute('data-id');

            // 親がなかった場合は自身のIDを取得
            if(dataId == null || dataId == undefined){
                dataId = ele.getAttribute('data-id');
            }
            // 更になかった場合は親の親のIDを取得
            if(dataId == null || dataId == undefined){
                dataId = ele.parentNode.parentNode.getAttribute('data-id');
            }

            // 一致する行番号を取得
            const idMap = this.links.map((obj) => { return obj.id; });
            let getLine = idMap.indexOf(dataId);

            // 行が存在する場合のみ変更
            if(getLine > -1){
                // 閉じていた場合
                if(this.links[getLine]['arrow_anime'] == false){
                    // サブメニューの表示
                    this.links[getLine]['childObj'] = {'d-none': false};
                    this.links[getLine]['arrow_anime'] = true;
                }else{
                    // サブメニューの非表示
                    this.links[getLine]['childObj'] = {'d-none': true};
                    this.links[getLine]['arrow_anime'] = false;
                }
            }
        }
    }
};

</script>

<style scoped>
</style>
